module.exports = __webpack_public_path__ + "static/3-59de77cfd5e72196b6beb0b0c4aec2a6.png";